/** `expo-constants` → só o que a camada de dados lê: versão e o `extra` com o client ID do Google. */
const Constants = {
  expoConfig: {
    version: 'web',
    name: 'Kontto Web',
    extra: {
      // O mesmo "Web client" OAuth do app e do site (client ID é público). Vem do .env.local / Pages.
      googleWebClientId: (import.meta.env.VITE_GOOGLE_WEB_CLIENT_ID as string | undefined)?.trim() || undefined,
    } as Record<string, unknown>,
  },
  manifest: null,
  appOwnership: null,
  executionEnvironment: 'bare',
};
export default Constants;
